import { useEffect } from "react";

const useConfirmLeave = (condition) => {
	const handleBeforeUnload = (e) => {
		if (condition) {
			e.preventDefault();
			e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
		}
	};

	useEffect(() => {
		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [condition]);
};

export default useConfirmLeave;
